exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr.nohighlight:hover {\n  background: #fff !important; }\n\ntr.nohighlight a.br-icn-edit {\n  display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/history/history.component.scss
// module id = ../../../../../src/app/brds/widgets/history/history.component.scss
// module chunks = 10